import { createStackNavigator } from '@react-navigation/stack';
import { faUserGroup } from '@fortawesome/pro-regular-svg-icons';

import { Module } from '../Routes';
import { GuardianAppParamList } from '../typings/Params';
import { GuardianAppSchemas } from '../schemas/guardian-app';
import GuardianAppUsers from '../pages/guardian-app/Users';
import GuardianAppUserForm from '../pages/guardian-app/Users/GuardianAppUserForm';

export const guardianAppModule: Module<'GuardianApp'> = {
    path: '/guardian-app',
    stackNavigator: createStackNavigator<GuardianAppParamList>(),
    canAccess: (user, currentApp) => Boolean(user && !currentApp.isAgentApp),
    icon: require('../../assets/icon_guardian_app.png'),
    logo: require('../../assets/logo_guardian_app.png'),
    label: 'guardianApp',
    navigate: (navigation) => navigation.navigate('GuardianApp'),
    schemas: GuardianAppSchemas,
    screens: {
        GuardianAppUsers: {
            path: 'users',
            selectedItem: 'users',
            component: GuardianAppUsers,
            label: 'supportedPeople',
            canAccess: (user) => Boolean(
                user?.isAdmin
                || user?.permissions.guardian_app_module_access
            ),
            accessInformation: {
                icon: faUserGroup,
                navigate: (navigation) => navigation.navigate('GuardianApp', { screen: 'GuardianAppUsers' }),
            },
            initialParams: () => ({
                page: 1,
                limit: 25,
            }),
        },
        GuardianAppUser: {
            path: 'users/form/:id?',
            selectedItem: 'users',
            component: GuardianAppUserForm,
            label: 'supportedPeople',
            canAccess: (user) => Boolean(
                user?.isAdmin
                || user?.permissions.guardian_app_module_access
            ),
        },
    }
};
